import React, { Fragment, useRef } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { PencilSquareIcon, CheckIcon, TrashIcon, ClockIcon, ArrowPathIcon } from '@heroicons/react/24/outline'
import Swal from 'sweetalert2';
import moment from 'moment';

const formatTime = (dateTimeString) => {
    if (!dateTimeString) return '';
    const dateTime = new Date(dateTimeString);
    const hours = dateTime.getHours().toString().padStart(2, '0');
    const minutes = dateTime.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
};

const SelectGiustificativoModal = ({ 
    selectedJustification, 
    selectedDescription, 
    selectedEmployee,
    selectedJustificationType,
    justificationsOfType,
    onJustificationSelected,
    onClose
}) => {

    const cancelButtonRef = useRef(null);


    if (!selectedEmployee || !selectedJustification) return null;

    const formatJustification = (justification) => {
        const startDate = moment(justification.datetime_from);
        const endDate = moment(justification.datetime_to);
        const duration = justification.duration / 60;
        const formattedDuration = Number.isInteger(duration) ? duration.toFixed(0) : duration.toFixed(2);
        
        // TODO - add check for same day - sistemare meglio la condizione del messaggio sulle fasce della JR da mostrare

        // if (startDate.isSame(endDate, 'day')) {
        //     return `Dalle ore ${startDate.format('HH:mm')} alle ore ${endDate.format('HH:mm')} - Durata: ${formattedDuration}`;
        // } 
        
        return `Dalle ore ${startDate.format('HH:mm')} alle ore ${endDate.format('HH:mm')} - Durata: ${formattedDuration}`;
    };
    

    return (
        <Transition.Root show={true} as={Fragment}>
            <Dialog as="div" className="fixed inset-0 overflow-y-auto" onClose={() => {}} initialFocus={cancelButtonRef} style={{ zIndex: '100'}}>
                <div className="flex items-start justify-center min-h-screen px-4 text-center sm:block sm:p-0">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
                    </Transition.Child>

                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <div className="inline-block bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-2/3 sm:w-1/3 mt-20 sm:mt-30 top-0">
                            <div className="text-center flex items-center justify-center bg-indigo-200 p-2">
                                <Dialog.Title as="h3" className="text-lg font-semibold text-indigo-700">
                                    Seleziona il giustificativo
                                </Dialog.Title>
                            </div>
                        
                            <p className='text-indigo-700 text-sm font-semibold text-center py-2'>{selectedDescription}</p>
                            {justificationsOfType
                                .sort((a, b) => new Date(a.datetime_from) - new Date(b.datetime_from))
                                .map(justification => {
                                    const key = justification.id || `${justification.description}-${justification.datetime_from}-${justification.code}`;
                                    
                                    return (
                                        <div
                                            key={key}
                                            className='my-2 mx-4 cursor-pointer border shadow-md p-2 rounded-md hover:bg-indigo-100 text-sm'
                                            onClick={() => {
                                                onJustificationSelected(justification.description || justification.code, selectedEmployee, selectedJustification, justification.id, justification.status);
                                                onClose();
                                            }}
                                        >
                                            {formatJustification(justification)}
                                        </div>
                                    );
                                })
                            }
                            <div className='text-center py-3'>
                                <button onClick={onClose} className='bg-indigo-500 text-white text-sm px-4 py-2 rounded-md hover:bg-indigo-600 focus:outline-none focus:bg-indigo-600 font-semibold'>Chiudi</button>
                            </div>
                            
                        </div>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition.Root>
    );
};

export default SelectGiustificativoModal;
